export interface Order {
  id: string;
  customerName: string;
  phone: string;
  city: string;
  district: string;
  address: string;
  productName: string;
  productType: 'isikli_tablo' | 'fener_tabela' | 'mdf_dekoratif' | 'arac_logo_set' | 'ozel_tasarim';
  quantity: number;
  amount: number;
  paymentType: 'kapida_odeme' | 'havale' | 'kredi_karti';
  paymentStatus: 'bekleniyor' | 'tahsil_edildi' | 'kismi_tahsil' | 'iade' | 'iptal';
  orderDate: string;
  estimatedDelivery: string;
  deliveryDate: string | null;
  note: string;
  customerRequest: string;
  hasLogoFile: boolean;
  orderSource: 'instagram_dm' | 'whatsapp' | 'reklam' | 'tavsiye' | 'manuel';
  status: 'yeni' | 'cizimde' | 'cizim_onay' | 'kesimde' | 'aydinlatma' | 'test' | 'paketleme' | 'kargoya_hazir' | 'kargoda' | 'teslim' | 'iptal' | 'sorunlu';
  productionStage: string;
  cargoCompany: string | null;
  cargoTrackingNo: string | null;
  cargoStatus: 'bekliyor' | 'hazir' | 'verildi' | 'yolda' | 'dagitimda' | 'teslim_edildi' | 'teslim_edilemedi' | 'iade_surecinde' | 'iade_geldi' | null;
  cargoDate: string | null;
  isLate: boolean;
  isUrgent: boolean;
}

export const orders: Order[] = [
  {
    id: 'TBL-2024-001',
    customerName: 'Ahmet Yılmaz',
    phone: '905321234567',
    city: 'İstanbul',
    district: 'Kadıköy',
    address: 'Caferağa Mah. Moda Cad. No:12 D:5, Kadıköy/İstanbul',
    productName: '12 Adet MDF Araç Logosu',
    productType: 'arac_logo_set',
    quantity: 1,
    amount: 999,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-17',
    estimatedDelivery: '2026-06-24',
    deliveryDate: null,
    note: 'Acil işlem, hediye olarak alındı.',
    customerRequest: 'BMW logosu set istiyor, renkli tercih edecek.',
    hasLogoFile: true,
    orderSource: 'instagram_dm',
    status: 'kesimde',
    productionStage: 'Kesim tamamlandı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: true,
  },
  {
    id: 'TBL-2024-002',
    customerName: 'Zeynep Kaya',
    phone: '905356789012',
    city: 'Ankara',
    district: 'Çankaya',
    address: 'Yıldızevler Mah. 4. Cad. No:22, Çankaya/Ankara',
    productName: 'İç Mekan Işıklı Tablo',
    productType: 'isikli_tablo',
    quantity: 2,
    amount: 1800,
    paymentType: 'havale',
    paymentStatus: 'tahsil_edildi',
    orderDate: '2026-06-16',
    estimatedDelivery: '2026-06-25',
    deliveryDate: null,
    note: 'Oturma odası için.',
    customerRequest: 'Doğa manzarası temalı, soft tonlarda ışık.',
    hasLogoFile: false,
    orderSource: 'whatsapp',
    status: 'aydinlatma',
    productionStage: 'Elektrik bağlantısı yapıldı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-003',
    customerName: 'Mehmet Demir',
    phone: '905441112233',
    city: 'İzmir',
    district: 'Bornova',
    address: 'Kazımdirik Mah. Sanayi Cad. No:5, Bornova/İzmir',
    productName: 'Fener Tabela',
    productType: 'fener_tabela',
    quantity: 1,
    amount: 2400,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-15',
    estimatedDelivery: '2026-06-22',
    deliveryDate: null,
    note: 'Dükkan için.',
    customerRequest: 'İşletme logosu ile özel tasarım, kırmızı-siyah renk.',
    hasLogoFile: true,
    orderSource: 'manuel',
    status: 'kargoya_hazir',
    productionStage: 'Paketleme tamamlandı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: 'hazir',
    cargoDate: null,
    isLate: false,
    isUrgent: true,
  },
  {
    id: 'TBL-2024-004',
    customerName: 'Ayşe Öztürk',
    phone: '905551234567',
    city: 'Bursa',
    district: 'Osmangazi',
    address: 'Altıparmak Mah. Cumhuriyet Cad. No:88, Osmangazi/Bursa',
    productName: '12 Adet MDF Araç Logosu',
    productType: 'arac_logo_set',
    quantity: 1,
    amount: 999,
    paymentType: 'kredi_karti',
    paymentStatus: 'tahsil_edildi',
    orderDate: '2026-06-14',
    estimatedDelivery: '2026-06-21',
    deliveryDate: '2026-06-21',
    note: '',
    customerRequest: 'Mercedes logo set, standart tasarım.',
    hasLogoFile: false,
    orderSource: 'reklam',
    status: 'teslim',
    productionStage: 'Tamamlandı',
    cargoCompany: 'MNG Kargo',
    cargoTrackingNo: 'MNG2024067890',
    cargoStatus: 'teslim_edildi',
    cargoDate: '2026-06-19',
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-005',
    customerName: 'Can Yıldız',
    phone: '905421112233',
    city: 'Antalya',
    district: 'Muratpaşa',
    address: 'Kızıltoprak Mah. Ali Çetinkaya Cad. No:15, Muratpaşa/Antalya',
    productName: 'Kişiye Özel İsimli Tablo',
    productType: 'ozel_tasarim',
    quantity: 1,
    amount: 750,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-17',
    estimatedDelivery: '2026-06-26',
    deliveryDate: null,
    note: 'Eşine hediye.',
    customerRequest: '"Can & Deniz" yazılı, kalp figürlü, pembe aydınlatma.',
    hasLogoFile: true,
    orderSource: 'tavsiye',
    status: 'cizimde',
    productionStage: 'Çizim başladı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-006',
    customerName: 'Fatma Şahin',
    phone: '905351112233',
    city: 'İstanbul',
    district: 'Üsküdar',
    address: 'Çarşı Mah. Hakimiyeti Milliye Cad. No:42, Üsküdar/İstanbul',
    productName: 'İç Mekan Işıklı Tablo',
    productType: 'isikli_tablo',
    quantity: 1,
    amount: 900,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-12',
    estimatedDelivery: '2026-06-19',
    deliveryDate: null,
    note: 'Doğum günü hediyesi olacaktı ama gecikti.',
    customerRequest: 'İstanbul silüeti, gece modu ışıklandırma.',
    hasLogoFile: false,
    orderSource: 'instagram_dm',
    status: 'sorunlu',
    productionStage: 'Işık testinde sorun çıktı, tekrar işlem gerekiyor',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: true,
    isUrgent: true,
  },
  {
    id: 'TBL-2024-007',
    customerName: 'Kemal Arslan',
    phone: '905331234567',
    city: 'Konya',
    district: 'Selçuklu',
    address: 'Sancak Mah. Yeni İstanbul Cad. No:77, Selçuklu/Konya',
    productName: 'İşletmeye Özel Logo Tablo',
    productType: 'ozel_tasarim',
    quantity: 3,
    amount: 3600,
    paymentType: 'havale',
    paymentStatus: 'tahsil_edildi',
    orderDate: '2026-06-17',
    estimatedDelivery: '2026-07-01',
    deliveryDate: null,
    note: 'Şirket ofisi için 3 adet.',
    customerRequest: 'Logo renklerine uygun aydınlatma, kurumsal görünüm.',
    hasLogoFile: true,
    orderSource: 'tavsiye',
    status: 'yeni',
    productionStage: 'Sipariş alındı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-008',
    customerName: 'Elif Çelik',
    phone: '905461112233',
    city: 'Gaziantep',
    district: 'Şahinbey',
    address: 'Batıkent Mah. Necip Fazıl Cad. No:33, Şahinbey/Gaziantep',
    productName: '12 Adet MDF Araç Logosu',
    productType: 'arac_logo_set',
    quantity: 2,
    amount: 1998,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-16',
    estimatedDelivery: '2026-06-23',
    deliveryDate: null,
    note: 'İki araç için ayrı set.',
    customerRequest: 'Audi ve Volkswagen logo setleri.',
    hasLogoFile: false,
    orderSource: 'whatsapp',
    status: 'kargoda',
    productionStage: 'Kargoya verildi',
    cargoCompany: 'Aras Kargo',
    cargoTrackingNo: 'ARAS2024062345',
    cargoStatus: 'yolda',
    cargoDate: '2026-06-17',
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-009',
    customerName: 'Mustafa Aydın',
    phone: '905561112233',
    city: 'İstanbul',
    district: 'Beylikdüzü',
    address: 'Barış Mah. Atatürk Bulvarı No:120, Beylikdüzü/İstanbul',
    productName: 'Fener Tabela',
    productType: 'fener_tabela',
    quantity: 1,
    amount: 2200,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-13',
    estimatedDelivery: '2026-06-20',
    deliveryDate: null,
    note: '',
    customerRequest: 'Modern tasarım, beyaz zemin üzerine siyah yazı.',
    hasLogoFile: true,
    orderSource: 'instagram_dm',
    status: 'cizim_onay',
    productionStage: 'Müşteri onayı bekleniyor',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: true,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-010',
    customerName: 'Deniz Koç',
    phone: '905521112233',
    city: 'Adana',
    district: 'Seyhan',
    address: 'Kurtuluş Mah. Ziyapaşa Bulvarı No:55, Seyhan/Adana',
    productName: 'MDF Dekoratif Ürün',
    productType: 'mdf_dekoratif',
    quantity: 4,
    amount: 600,
    paymentType: 'kredi_karti',
    paymentStatus: 'tahsil_edildi',
    orderDate: '2026-06-17',
    estimatedDelivery: '2026-06-24',
    deliveryDate: null,
    note: 'Küçük dekoratif ürünler, kargosu kolay.',
    customerRequest: 'Geometrik desenli, farklı boyutlarda.',
    hasLogoFile: false,
    orderSource: 'manuel',
    status: 'test',
    productionStage: 'Ürün kontrol edildi, sorun yok',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: false,
  },
  {
    id: 'TBL-2024-011',
    customerName: 'Selin Yalçın',
    phone: '905571112233',
    city: 'İstanbul',
    district: 'Beşiktaş',
    address: 'Levent Mah. Büyükdere Cad. No:199, Beşiktaş/İstanbul',
    productName: 'Araç Temalı Özel Tasarım Tablo',
    productType: 'ozel_tasarim',
    quantity: 1,
    amount: 1500,
    paymentType: 'havale',
    paymentStatus: 'tahsil_edildi',
    orderDate: '2026-06-11',
    estimatedDelivery: '2026-06-18',
    deliveryDate: null,
    note: 'VIP müşteri, özen gösterilecek.',
    customerRequest: 'Klasik araba temalı, vintage görünüm, amber ışık.',
    hasLogoFile: true,
    orderSource: 'tavsiye',
    status: 'paketleme',
    productionStage: 'Paketleme başladı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: 'bekliyor',
    cargoDate: null,
    isLate: true,
    isUrgent: true,
  },
  {
    id: 'TBL-2024-012',
    customerName: 'Barış Tekin',
    phone: '905581112233',
    city: 'İzmir',
    district: 'Karşıyaka',
    address: 'Bostanlı Mah. Cemal Gürsel Cad. No:88, Karşıyaka/İzmir',
    productName: 'İç Mekan Işıklı Tablo',
    productType: 'isikli_tablo',
    quantity: 1,
    amount: 950,
    paymentType: 'kapida_odeme',
    paymentStatus: 'bekleniyor',
    orderDate: '2026-06-17',
    estimatedDelivery: '2026-06-25',
    deliveryDate: null,
    note: '',
    customerRequest: 'Deniz manzarası, mavi tonlarda aydınlatma.',
    hasLogoFile: false,
    orderSource: 'whatsapp',
    status: 'yeni',
    productionStage: 'Sipariş alındı',
    cargoCompany: null,
    cargoTrackingNo: null,
    cargoStatus: null,
    cargoDate: null,
    isLate: false,
    isUrgent: false,
  },
];

export const activityLog = [
  { id: 1, orderId: 'TBL-2024-010', action: 'Test aşaması tamamlandı', user: 'Ali Usta', time: '14:35' },
  { id: 2, orderId: 'TBL-2024-008', action: 'Kargoya verildi - Aras Kargo', user: 'Ayşe Hanım', time: '13:20' },
  { id: 3, orderId: 'TBL-2024-001', action: 'Kesim tamamlandı, aydınlatmaya geçti', user: 'Mehmet Usta', time: '12:15' },
  { id: 4, orderId: 'TBL-2024-005', action: 'Çizim başladı', user: 'Ali Usta', time: '11:00' },
  { id: 5, orderId: 'TBL-2024-003', action: 'Paketleme tamamlandı, kargoya hazır', user: 'Ayşe Hanım', time: '10:45' },
  { id: 6, orderId: 'TBL-2024-011', action: 'Paketleme başladı', user: 'Mehmet Usta', time: '10:20' },
  { id: 7, orderId: 'TBL-2024-007', action: 'Yeni sipariş kaydedildi', user: 'Ayşe Hanım', time: '09:50' },
  { id: 8, orderId: 'TBL-2024-012', action: 'Yeni sipariş kaydedildi', user: 'Ayşe Hanım', time: '09:15' },
  { id: 9, orderId: 'TBL-2024-002', action: 'Elektrik bağlantısı yapıldı', user: 'Ali Usta', time: '08:40' },
  { id: 10, orderId: 'TBL-2024-006', action: 'Sorunlu işaretlendi - Işık testi başarısız', user: 'Mehmet Usta', time: '08:10' },
];

export const todaysTasks = [
  { id: 1, orderId: 'TBL-2024-001', task: 'Aydınlatma montajına başla', priority: 'high' },
  { id: 2, orderId: 'TBL-2024-005', task: 'Çizim tamamla ve müşteriye gönder', priority: 'medium' },
  { id: 3, orderId: 'TBL-2024-006', task: 'Arızalı LED değişimi yap', priority: 'high' },
  { id: 4, orderId: 'TBL-2024-010', task: 'Paketlemeye al', priority: 'medium' },
  { id: 5, orderId: 'TBL-2024-011', task: 'Paketleme tamamla, kargoya hazırla', priority: 'high' },
  { id: 6, orderId: 'TBL-2024-003', task: 'Kargo firmasına teslim et', priority: 'high' },
  { id: 7, orderId: 'TBL-2024-009', task: 'Müşteri onayı için takip yap', priority: 'medium' },
];

export const productTypes = [
  { value: 'isikli_tablo', label: 'İç Mekan Işıklı Tablo' },
  { value: 'fener_tabela', label: 'Fener Tabela' },
  { value: 'mdf_dekoratif', label: 'MDF Dekoratif Ürün' },
  { value: 'arac_logo_set', label: '12 Adet MDF Araç Logosu' },
  { value: 'ozel_tasarim', label: 'Özel Tasarım' },
];

export const statusLabels: Record<string, string> = {
  yeni: 'Yeni Sipariş',
  cizimde: 'Çizim Aşamasında',
  cizim_onay: 'Çizim Onayı Bekliyor',
  kesimde: 'Kesim Aşamasında',
  aydinlatma: 'Aydınlatma / Montaj',
  test: 'Test Aşamasında',
  paketleme: 'Paketleme',
  kargoya_hazir: 'Kargoya Hazır',
  kargoda: 'Kargoda',
  teslim: 'Teslim Edildi',
  iptal: 'İptal',
  sorunlu: 'Sorunlu',
};

export const statusColors: Record<string, string> = {
  yeni: 'bg-status-blue/10 text-status-blue border-status-blue/30',
  cizimde: 'bg-status-purple/10 text-status-purple border-status-purple/30',
  cizim_onay: 'bg-status-purple/10 text-status-purple border-status-purple/30',
  kesimde: 'bg-status-orange/10 text-status-orange border-status-orange/30',
  aydinlatma: 'bg-status-yellow/10 text-status-yellow border-status-yellow/30',
  test: 'bg-status-yellow/10 text-status-yellow border-status-yellow/30',
  paketleme: 'bg-status-navy/10 text-status-navy border-status-navy/30',
  kargoya_hazir: 'bg-status-navy/10 text-status-navy border-status-navy/30',
  kargoda: 'bg-status-sky/10 text-status-sky border-status-sky/30',
  teslim: 'bg-status-green/10 text-status-green border-status-green/30',
  iptal: 'bg-status-gray/10 text-status-gray border-status-gray/30',
  sorunlu: 'bg-status-red/10 text-status-red border-status-red/30',
};

export const cargoStatusLabels: Record<string, string> = {
  bekliyor: 'Kargo Bekliyor',
  hazir: 'Kargoya Hazır',
  verildi: 'Kargoya Verildi',
  yolda: 'Yolda',
  dagitimda: 'Dağıtımda',
  teslim_edildi: 'Teslim Edildi',
  teslim_edilemedi: 'Teslim Edilemedi',
  iade_surecinde: 'İade Sürecinde',
  iade_geldi: 'İade Geldi',
};

export const paymentStatusLabels: Record<string, string> = {
  bekleniyor: 'Ödeme Bekleniyor',
  tahsil_edildi: 'Tahsil Edildi',
  kismi_tahsil: 'Kısmi Tahsil',
  iade: 'İade',
  iptal: 'İptal',
};

export const orderSourceLabels: Record<string, string> = {
  instagram_dm: 'Instagram DM',
  whatsapp: 'WhatsApp',
  reklam: 'Reklam',
  tavsiye: 'Tavsiye',
  manuel: 'Manuel',
};